// extracted by mini-css-extract-plugin
module.exports = {"itinerary_travelInfo_PC":"itinerary_travelInfo_PC--satyF"};